import Loader from 'semantic-ui-react/dist/es/elements/Loader';
import './Loader.css';

export default Loader;
